<div [class]="` ${mainClass()}`">
  <ion-row class="g-0">
    <ion-col sizeXl="4" sizeXs="2" class="d-flex justify-content-end">
      <ion-icon [src]="iconSrc()" class="warning-icon"></ion-icon>
    </ion-col>
    <ion-col sizeXl="5" sizeXs="9">
      <ion-text [class]="`${headerClass()} font-family-bold safety_defect_status d-inline-block`">
        {{titleValue() | translate}}
      </ion-text>
      <br>
      <ion-text [class]="`${descClass()} safety_defect_message d-inline-block mt-2`">
        {{titleDesc() | translate}}
      </ion-text>
    </ion-col>
  </ion-row>
</div>